import { useEffect, useRef } from 'react';

/** Attempts tracking once per mount when enabled, even if tracking throws. */
export function useTrackEventOnce({ isEnabled, onTrack }: UseTrackEventOnceProps): void {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!isEnabled || hasTracked.current) {
      return;
    }

    hasTracked.current = true;
    onTrack();
  }, [isEnabled, onTrack]);
}

export interface UseTrackEventOnceProps {
  isEnabled: boolean;
  onTrack: () => void;
}
